import { Typography } from "@mui/material";
import { styled, Box, Stack } from "@mui/system";
import theme from "../../../theme";

export const ReportsContainer = styled(Box)`
  border-top: 1px solid ${theme.palette.grey[100]};
  background: ${theme.palette.grey[50]};
  padding: 8px 16px 16px 16px;
  margin-top: 10px;
`;

export const ReportsHeader = styled(Typography)`
  font-size: 11px;
  font-weight: 600;
  color: ${theme.palette.text.secondary};
  text-transform: uppercase;
  letter-spacing: 0.5px;
  margin-bottom: 8px;
`;

export const ReportsList = styled(Stack)`
  gap: 8px;
`;

export const NoReportsText = styled(Typography)`
  font-size: 12px;
  color: ${theme.palette.text.secondary};
  font-style: italic;
  text-align: center;
`;
